import "./App.css";
import "./main.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
  useLocation,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { login } from "./features/authSlice.js";
import { clearLoginNotification } from "./features/authSlice";
import { logout } from "./features/authSlice.js";
import {
  setOrderTotalUnread,
  setInvoiceTotalUnread,
  setPaymentTotalUnread,
  setDebitTotalUnread,
} from "./features/unreadSlice";
import { TotalAmountContext } from "./contexts/TotalAmountContext";
import PrivateRoute from "./components/PrivateRoute";
import {
  Register2Guard,
  Register3Guard,
  Register4Guard,
} from "./components/RegisterRouteGuard";
import ProductListRouteGuard from "./components/ProductListRouteGuard";
import Navbarv1 from "./components/navbar/Navbar";
import Navbarv2 from "./components/navbar_v2/Navbar";
import ExploreBrandv1 from "./pages/explorebrand/ExploreBrand.js";
import ExploreBrandv2 from "./pages/explorebrand_v2/ExploreBrand.js";
import ExploreProductv1 from "./pages/exploreproduct/ExploreProduct.js";
import ExploreProductv2 from "./pages/exploreproduct_v2/ExploreProduct.js";
import NewRequestv2 from "./pages/newrequest_v2/NewRequest.js";
import Footerv1 from "./components/footer/Footer";
import Footerv2 from "./components/footer_v2/Footer";
import SideFeaturev1 from "./components/sidefeature/SideFeature.js";
import SideFeaturev2 from "./components/sidefeature_v2/SideFeature.js";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import Homev1 from "./pages/home/Home";
import Homev2 from "./pages/home_v2/Home";
import Eventv1 from "./pages/event/Event";
import Eventv2 from "./pages/event_v2/Event";
import Login from "./pages/login/Login";
import Salesman_Login from "./pages/login/Salesman_Login.js";
import LoginNotifv1 from "./components/loginnotif/LoginNotif";
import LoginNotifv2 from "./components/loginnotif_v2/LoginNotif";
import ForgetPass from "./pages/forgetpass/ForgetPass";
import ForgetPass2 from "./pages/forgetpass/ForgetPass2";
import ResetPassword from "./pages/resetpassword/ResetPassword.js";
import Register from "./pages/register/Register";
import Register2 from "./pages/register/Register2";
import Register3 from "./pages/register/Register3";
import Register4 from "./pages/register/Register4";
import RegisterValidation from "./pages/register/RegisterValidation.js";
import MyWishlistv1 from "./pages/mywishlist/MyWishlist.js";
import MyWishlistv2 from "./pages/mywishlist_v2/MyWishlist.js";
import MyShoppingCartv1 from "./pages/myshoppingcart/MyShoppingCart";
import Checkoutv1 from "./pages/myshoppingcart/Checkout";
import MyShoppingCartv2 from "./pages/myshoppingcart_v2/MyShoppingCart";
import Checkoutv2 from "./pages/myshoppingcart_v2/Checkout";
import ProductDetailv1 from "./pages/productdetail/ProductDetail";
import ProductDetailv2 from "./pages/productdetail_v2/ProductDetail";
// import PurchaseHistoryDetail from "./pages/purchasehistorydetail/PurchaseHistoryDetail";
import PackageProductDetailv1 from "./pages/packageproductdetail/PackageProductDetail.js";
import PackageProductDetailv2 from "./pages/packageproductdetail_v2/PackageProductDetail.js";
import GroupPackageDetail from "./pages/grouppackagedetail/GroupPackageDetail.js";
import ProductListv1 from "./pages/productlist/ProductList.js";
import ProductListv2 from "./pages/productlist_v2/ProductList.js";
import PreOrder from "./pages/preorder/PreOrder";
import CompareProductv1 from "./pages/compareproduct/CompareProduct";
import CompareProductv2 from "./pages/compareproduct_v2/CompareProduct";
import BrandServiceCenterv1 from "./pages/brandservicecenter/BrandServiceCenter";
import BrandServiceCenterv2 from "./pages/brandservicecenter_v2/BrandServiceCenter";
import RefundReturnPolicy from "./pages/refundreturnpolicy/RefundReturnPolicy";
import AboutUs from "./pages/aboutus/AboutUs";
import FAQ from "./pages/faq/FAQ";
import PrivacyPolicy from "./pages/privacypolicy/PrivacyPolicy";
import TermsConditions from "./pages/termsconditions/TermsConditions";
import MyLoyalty from "./pages/myloyalty/MyLoyalty";
import MemberTier from "./pages/membertier/MemberTier";
import MyCredit from "./pages/mycredit/MyCredit";
import CreditDetail from "./pages/creditdetail/CreditDetail";
import MyAccount from "./pages/myprofile/MyAccount";
import CompanyInfo from "./pages/myprofile/CompanyInfo";
import BranchManage from "./pages/myprofile/BranchManage";
import UserManage from "./pages/myprofile/UserManage";
import PaymentManage from "./pages/myprofile/PaymentManage";
import AllOrderv1 from "./pages/myorder/AllOrder.js";
import AllOrderv2 from "./pages/myorder_v2/AllOrder.js";
import RefundReturn from "./pages/myorder/RefundReturn";
import UploadChequev1 from "./pages/uploadcheque/UploadCheque";
import UploadChequev2 from "./pages/uploadcheque_v2/UploadCheque";
import OrderDetailv1 from "./pages/orderdetail/OrderDetail";
import OrderDetailv2 from "./pages/orderdetail_v2/OrderDetail";
import RefundOrderDtl from "./pages/orderdetail/RefundOrderDtl";
import TrackProgress from "./pages/trackprogress/TrackProgress";
import AllRepair from "./pages/myrepair/AllRepair";
import RepairDetail from "./pages/repairdetail/RepairDetail";
import TrackingDetail from "./pages/trackingdetail/TrackingDetail";
import OrderTrackingDetail from "./pages/trackingdetail/OrderTrackingDetail";
import UnityPayLater from "./pages/unitypaylater/UnityPayLater";
import InvoiceDetail from "./pages/invoicedetail/InvoiceDetail";
import MyDebit from "./pages/mydebit/MyDebit";
import DebitDetail from "./pages/debitdetail/DebitDetail";
import MyContra from "./pages/mycontra/MyContra";
import ContraDetail from "./pages/contradetail/ContraDetail";
import TransactionDetail from "./pages/transactiondetail/TransactionDetail";
import MyPaymentCart from "./pages/mypaymentcart/MyPaymentCart";
import MyPaymentHistory from "./pages/mypaymenthistory/MyPaymentHistory";
import TransDtlPayment from "./pages/transactiondetail/TransDtlPayment";
import MyNotification from "./pages/mynotification/MyNotification";
import AllDocument from "./pages/mydocument/AllDocument";
import AfterSalesService from "./pages/aftersalesservice/AfterSalesService.js";
import RegisterSerialNo from "./pages/aftersalesservice/registerserialno/RegisterSerialNo.js";
import RegisterSerialNoBrunei from "./pages/aftersalesservice/registerserialnobrunei/RegisterSerialNoBrunei.js";
// import RegisterSerialNoSingle from "./pages/aftersalesservice/registerserialnosingle/RegisterSerialNoSingle.js";
import MenuCenter from "./pages/aftersalesservice/menucenter/MenuCenter.js";
import CheckWarrantyStatus from "./pages/aftersalesservice/checkwarrantystatus/CheckWarrantyStatus.js";
import WarrantyPolicy from "./pages/aftersalesservice/warrantypolicy/WarrantyPolicy.js";
import UserManual from "./pages/aftersalesservice/usermanual/UserManual.js";
import UserManualSafety from "./pages/aftersalesservice/usermanualsafety/UserManualSafety.js";
import UserManualInstallation from "./pages/aftersalesservice/usermanualinstallation/UserManualInstallation.js";
import UserManualOperating from "./pages/aftersalesservice/usermanualoperating/UserManualOperating.js";
import UserManualMaintenance from "./pages/aftersalesservice/usermanualmaintenance/UserManualMaintenance.js";
import ErrorCode from "./pages/aftersalesservice/errorcode/ErrorCode.js";
import MyTicket from "./pages/aftersalesservice/myticket/MyTicket.js";
import MyTicketDetail from "./pages/aftersalesservice/myticketdetail/MyTicketDetail.js";
import TicketSubmission from "./pages/aftersalesservice/ticketsubmission/TicketSubmission.js";
import TicketSubmitted from "./pages/aftersalesservice/ticketsubmitted/TicketSubmitted.js";
import NewInstallation from "./pages/aftersalesservice/newinstallation/NewInstallation.js";
import Preview from "./pages/aftersalesservice/preview/Preview.js";
import PreviewWarrantyPolicy from "./pages/aftersalesservice/preview/PreviewWarrantyPolicy.js";
import PreviewUserManual from "./pages/aftersalesservice/preview/PreviewUserManual.js";
import PreviewUserManualSections from "./pages/aftersalesservice/preview/PreviewUserManualSections.js";
import PreviewErrorCode from "./pages/aftersalesservice/preview/PreviewErrorCode.js";
import MultiPurpose from "./components/multipurpose/MultiPurpose.js";
import Test from "./pages/test/Test";
import ApiService from "./components/Api_services";
import FaviconManager from "./components/faviconmanager/FaviconManager.js";
import { LanguageProvider } from "./pages/aftersalesservice/LanguageContext.js";
import { REDIRECT_LOGIN_URL, VERSION } from "./constants.js";

function ProductDetailWithKey({ Component, fetchCounts }) {
  const location = useLocation();
  const navKey = location.state?.navKey;
  return <Component key={navKey} fetchCounts={fetchCounts} />;
}

function BuyNowCartCleanup() {
  const location = useLocation();
  const prevLocationRef = useRef({
    pathname: location.pathname,
    search: location.search,
  });

  useEffect(() => {
    const normalize = (path) => (path || "").replace(/\/+$/, "") || "/";
    const prev = prevLocationRef.current;
    prevLocationRef.current = {
      pathname: location.pathname,
      search: location.search,
    };

    const prevPath = normalize(prev.pathname);
    const currPath = normalize(location.pathname);
    const wasCheckoutFlow =
      prevPath === "/checkout" || prevPath === "/uploadcheque";
    const isCheckoutFlow =
      currPath === "/checkout" || currPath === "/uploadcheque";

    if (!wasCheckoutFlow || isCheckoutFlow) {
      return;
    }
    if (!localStorage.getItem("access_token")) {
      return;
    }
    ApiService.removeBuyNowCart();
  }, [location.pathname, location.search]);

  return null;
}

const App = () => {
  const dispatch = useDispatch();

  // const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  // const [selectedCategoryCode, setSelectedCategoryCode] = useState("");
  const [cartCount, setCartCount] = useState(0);
  const [cartByPricingTypeCount, setCartByPricingTypeCount] = useState({});
  const [wishlistCount, setWishlistCount] = useState(0);
  const [orderCount, setOrderCount] = useState(0);
  const [invoiceCount, setInvoiceCount] = useState(0);
  const [paymentCount, setPaymentCount] = useState(0);
  const [debitCount, setDebitCount] = useState(0);
  // const [showLoginNotice, setShowLoginNotice] = useState(false);
  const [unsuccessfulTotal, setUnsuccessfulTotal] = useState(0);
  const [overdueTotal, setOverdueTotal] = useState(0);
  const [unpaidOrderTotal, setUnpaidOrderTotal] = useState(0);
  const [appVersion, setAppVersion] = useState(null);
  const hideNavAndFooter =
    window.location.pathname.startsWith("/aftersalesservice");

  const user = useSelector((state) => state.auth.user);
  const is_subuser = user?.is_subuser || false;
  // const sub_branch = user?.sub_branch || "";
  // const subBranchIds = Array.isArray(sub_branch)
  //   ? sub_branch
  //   : typeof sub_branch === "string" && sub_branch.includes(",")
  //   ? sub_branch.split(",").map((id) => id.trim()).filter(Boolean)
  //   : sub_branch
  //   ? [sub_branch]
  //   : [];
  const showNotification = useSelector(
    (state) => state.auth.showLoginNotification,
  );

  const handleCloseNotification = () => {
    dispatch(clearLoginNotification());
  };

  useEffect(() => {
    if (window.location.pathname.startsWith("/aftersalesservice")) return;
    const accessToken = localStorage.getItem("access_token");
    if (accessToken && !user) {
      ApiService.getProfile().then((res) => {
        if (res.status === 200 && res.data) {
          dispatch(
            login({
              user: {
                name: res.data.name,
                email: res.data.email,
                profile_photo_url: res.data.profile_photo_url,
                is_subuser: res.data.is_subuser || false,
                subuser_id: res.data.subuser_id || "",
                sub_branch: res.data.sub_branch || null,
                main_id: res.data.main_id || null,
                salesman_id: res.data.salesman_id || null,
                company_name: res.data.company_name || "",
                has_cbd: res.data.has_cbd || false,
                has_term: res.data.has_term || false,
              },
              sub_role: res.data.sub_role || [],
            }),
          );
        } else if (res.status === 401) {
          dispatch(logout());
        }
      });
    }
  }, [user]);

  useEffect(() => {
    const onStorage = async (e) => {
      // react only to session keys
      if (e.key !== "access_token" && e.key !== "session_broadcast") return;

      const accessToken = localStorage.getItem("access_token");

      // token removed in another tab -> logout here
      if (!accessToken) {
        dispatch(logout());
        return;
      }

      // token changed in another tab -> refresh profile in this tab
      try {
        const res = await ApiService.getProfile();
        if (res?.status === 200 && res.data) {
          dispatch(
            login({
              user: {
                name: res.data.name,
                email: res.data.email,
                profile_photo_url: res.data.profile_photo_url,
                is_subuser: res.data.is_subuser || false,
                subuser_id: res.data.subuser_id || "",
                sub_branch: res.data.sub_branch || null,
                main_id: res.data.main_id || null,
                salesman_id: res.data.salesman_id || null,
                company_name: res.data.company_name || "",
                has_cbd: res.data.has_cbd || false,
                has_term: res.data.has_term || false,
              },
              sub_role: res.data.sub_role || [],
            }),
          );
        } else if (res?.status === 401) {
          dispatch(logout());
        }
      } catch {
        // on error prefer to logout to avoid stale profile
        dispatch(logout());
      }
    };

    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [dispatch]);

  const fetchCounts = async () => {
    if (window.location.pathname.startsWith("/aftersalesservice")) return;
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) {
      setCartCount(0);
      setCartByPricingTypeCount({});
      setWishlistCount(0);
      setOrderCount(0);
      setInvoiceCount(0);
      setPaymentCount(0);
      setDebitCount(0);
      dispatch(setOrderTotalUnread(0));
      dispatch(setInvoiceTotalUnread(0));
      dispatch(setPaymentTotalUnread(0));
      dispatch(setDebitTotalUnread(0));
      return;
    }
    try {
      const response = await ApiService.getAllStatusCount();
      if (response.status === 200 && response.data) {
        setCartCount(response.data.cart_total);
        setCartByPricingTypeCount(response.data.cart_by_pricing_type);
        setOrderCount(response.data.order_total);
        setInvoiceCount(response.data.invoice_total);
        setPaymentCount(response.data.payment_total);
        setDebitCount(response.data.debit_note_total);
        setWishlistCount(
          response.data.wishlist_available ??
            response.data.available_wishlist_items ??
            0,
        );
      }

      dispatch(setOrderTotalUnread(response.data.order_total));
      dispatch(setInvoiceTotalUnread(response.data.invoice_total));
      dispatch(setPaymentTotalUnread(response.data.payment_total));
      dispatch(setDebitTotalUnread(response.data.debit_note_total));
    } catch {
      setCartCount(0);
      setCartByPricingTypeCount({});
      setWishlistCount(0);
      setOrderCount(0);
      setInvoiceCount(0);
      setPaymentCount(0);
      setDebitCount(0);
      dispatch(setOrderTotalUnread(0));
      dispatch(setInvoiceTotalUnread(0));
      dispatch(setPaymentTotalUnread(0));
      dispatch(setDebitTotalUnread(0));
    }
  };

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (window.location.pathname.startsWith("/aftersalesservice")) return;
    ApiService.getUnsuccessfulAndOverdueTotal().then((res) => {
      if (res.status === 200 && res.data) {
        setUnsuccessfulTotal(Number(res.data.unsuccessful_total_amount) || 0);
        setOverdueTotal(Number(res.data.overdue_total_amount) || 0);
        setUnpaidOrderTotal(Number(res.data.unpaid_order_amount) || 0);
      }
    });
  }, [isAuthenticated]);

  useEffect(() => {
    fetchCounts();
  }, [isAuthenticated]);

  useEffect(() => {
    const handler = () => {
      // do not show session expired when in aftersalesservice
      const isAfterSalesRoute =
        window.location.pathname.startsWith("/aftersalesservice");
      if (isAfterSalesRoute) return;

      // 只在已登录时弹窗
      // if (isAuthenticated) setShowLoginNotice(true);
      if (isAuthenticated) window.location.href = REDIRECT_LOGIN_URL;
    };
    window.addEventListener("session-expired", handler);
    return () => window.removeEventListener("session-expired", handler);
  }, [isAuthenticated]);

  // MetaManager - uses window.location.pathname (no useLocation)
  function MetaManager() {
    useEffect(() => {
      const name = "viewport";
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = name;
        document.head.appendChild(meta);
      }

      const updateMeta = () => {
        const isAfterSales =
          window.location.pathname.startsWith("/aftersalesservice");
        const content = isAfterSales
          ? "width=device-width, initial-scale=1"
          : "width=1300, initial-scale=0.1";
        meta.setAttribute("content", content);
      };

      // initial set
      updateMeta();

      // patch history methods to detect SPA navigation (pushState/replaceState)
      const origPush = window.history.pushState;
      const origReplace = window.history.replaceState;
      window.history.pushState = function (...args) {
        origPush.apply(window.history, args);
        window.dispatchEvent(new window.CustomEvent("locationchange"));
      };
      window.history.replaceState = function (...args) {
        origReplace.apply(window.history, args);
        window.dispatchEvent(new window.CustomEvent("locationchange"));
      };

      return () => {
        // cleanup: restore originals and remove listeners
        window.history.pushState = origPush;
        window.history.replaceState = origReplace;
        window.removeEventListener("popstate", updateMeta);
        window.removeEventListener("locationchange", updateMeta);
      };
    }, []);

    return null;
  }

  // Check for new deployed version by polling public/version.json
  useEffect(() => {
    let mounted = true;

    const fetchVersion = async () => {
      try {
        const res = await fetch("/version.json?t=" + Date.now(), {
          cache: "no-store",
        });
        if (!res.ok) return;
        const data = await res.json();
        const latest = data?.version;
        if (!appVersion && mounted) {
          setAppVersion(latest);
        } else if (appVersion && latest && appVersion !== latest && mounted) {
          // immediately reload when a new version is detected
          window.location.reload();
        }
      } catch (e) {
        // ignore errors
      }
    };

    fetchVersion();
    // poll every 30 minutes
    const id = setInterval(fetchVersion, 30 * 60 * 1000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, [appVersion]);

  const ProductDetail = VERSION === "1" ? ProductDetailv1 : ProductDetailv2;
  const PackageProductDetail =
    VERSION === "1" ? PackageProductDetailv1 : PackageProductDetailv2;
  const Navbar = VERSION === "1" ? Navbarv1 : Navbarv2;
  const Footer = VERSION === "1" ? Footerv1 : Footerv2;
  const SideFeature = VERSION === "1" ? SideFeaturev1 : SideFeaturev2;
  const Home = VERSION === "1" ? Homev1 : Homev2;
  const ExploreProduct = VERSION === "1" ? ExploreProductv1 : ExploreProductv2;
  const ExploreBrand = VERSION === "1" ? ExploreBrandv1 : ExploreBrandv2;
  const MyWishlist = VERSION === "1" ? MyWishlistv1 : MyWishlistv2;
  const ProductList = VERSION === "1" ? ProductListv1 : ProductListv2;
  const CompareProduct = VERSION === "1" ? CompareProductv1 : CompareProductv2;
  const UploadCheque = VERSION === "1" ? UploadChequev1 : UploadChequev2;
  const BrandServiceCenter =
    VERSION === "1" ? BrandServiceCenterv1 : BrandServiceCenterv2;
  const MyShoppingCart = VERSION === "1" ? MyShoppingCartv1 : MyShoppingCartv2;
  const Checkout = VERSION === "1" ? Checkoutv1 : Checkoutv2;
  const Event = VERSION === "1" ? Eventv1 : Eventv2;
  const AllOrder = VERSION == "1" ? AllOrderv1 : AllOrderv2;
  const OrderDetail = VERSION == "1" ? OrderDetailv1 : OrderDetailv2;
  const LoginNotif = VERSION == "1" ? LoginNotifv1 : LoginNotifv2;

  return (
    <TotalAmountContext.Provider
      value={{
        unsuccessfulTotal,
        overdueTotal,
        unpaidOrderTotal,
      }}
    >
      <Router>
        <ScrollToTop />
        <BuyNowCartCleanup />
        <FaviconManager />
        {/* <meta name="viewport" content="width=1300, initial-scale=0.1"></meta> */}
        <MetaManager />
        <div className="app-container">
          {!hideNavAndFooter && (
            <Navbar
              cartCount={cartCount}
              wishlistCount={wishlistCount}
              fetchCounts={fetchCounts}
            />
          )}
          <main className="main-content">
            <Routes>
              <Route element={<PrivateRoute />}>
                <Route path="mywishlist" element={<MyWishlist />} />
                <Route
                  path="mywishlist/productdetail/:item_id"
                  element={
                    <ProductDetailWithKey
                      Component={ProductDetail}
                      fetchCounts={fetchCounts}
                    />
                  }
                />
                <Route
                  path="myshoppingcart"
                  element={
                    <MyShoppingCart
                      cartCount={cartCount}
                      cartByPricingTypeCount={cartByPricingTypeCount}
                      fetchCounts={fetchCounts}
                    />
                  }
                />
                <Route
                  path="myshoppingcart/productdetail/:item_id"
                  element={
                    <ProductDetailWithKey
                      Component={ProductDetail}
                      fetchCounts={fetchCounts}
                    />
                  }
                />
                <Route
                  path="myshoppingcart/grouppackagedetail/:item_id"
                  element={<GroupPackageDetail fetchCounts={fetchCounts} />}
                />
                <Route
                  path="myshoppingcart/packageproductdetail/:item_id"
                  element={<PackageProductDetail fetchCounts={fetchCounts} />}
                />
                <Route path="checkout" element={<Checkout />} />
                <Route path="newrequest" element={<NewRequestv2 />} />
                <Route path="myloyalty" element={<MyLoyalty />} />
                <Route path="membertier" element={<MemberTier />} />
                {/* <Route path="myaccount" element={<MyAccount />} />
                <Route path="companyinfo" element={<CompanyInfo />} />
                <Route path="branchmanage" element={<BranchManage />} />
                <Route path="usermanage" element={<UserManage />} />
                <Route path="paymentmanage" element={<PaymentManage />} /> */}
                <Route path="allorder" element={<AllOrder />} />
                <Route path="/orderdetail/:id" element={<OrderDetail />} />
                <Route
                  path="/orderTrackingDetail/:order_no"
                  element={<OrderTrackingDetail />}
                />
                <Route path="uploadcheque" element={<UploadCheque />} />
                {/* <Route path="allrepair" element={<AllRepair />} />
                <Route
                  path="/repairdetail/:repairId"
                  element={<RepairDetail />}
                />
                <Route
                  path="/trackingdetail/:repairId"
                  element={<TrackingDetail />}
                />
                <Route path="myinvoice" element={<UnityPayLater />} />
                <Route
                  path="/invoicedetail/:inv_no"
                  element={<InvoiceDetail />}
                />
                <Route path="mydebit" element={<MyDebit />} />
                <Route path="/debitdetail/:dn_no" element={<DebitDetail />} />
                <Route path="mycontra" element={<MyContra />} />
                <Route
                  path="/contradetail/:contra_id"
                  element={<ContraDetail />}
                />
                <Route
                  path="/transaction/:or_no"
                  element={<TransactionDetail />}
                />
                <Route path="mypaymentcart" element={<MyPaymentCart />} />
                <Route path="mypaymenthistory" element={<MyPaymentHistory />} />
                <Route
                  path="/transdtlpayment/:receiptId"
                  element={<TransDtlPayment />}
                />
                <Route path="mycredit" element={<MyCredit />} />
                <Route path="/creditdetail/:cn_no" element={<CreditDetail />} />
                <Route path="refundreturn" element={<RefundReturn />} />
                <Route
                  path="/refundorderdtl/:rn_no"
                  element={<RefundOrderDtl />}
                />
                <Route
                  path="/trackprogress/:rn_no"
                  element={<TrackProgress />}
                />
                <Route path="alldocument" element={<AllDocument />} />
                <Route path="mynotification" element={<MyNotification />} /> */}
              </Route>

              {/* <Route element={<Register2Guard />}>
                <Route path="register2" element={<Register2 />} />
              </Route>
              <Route element={<Register3Guard />}>
                <Route path="register3" element={<Register3 />} />
              </Route>
              <Route element={<Register4Guard />}>
                <Route path="register4" element={<Register4 />} />
              </Route> */}

              {/* <Route
                path="productlist"
                element={
                  <Layout>
                    {({
                      brandList,
                      productGroupList,
                      attributeList,
                      filteredItemName,
                      setClearInput,
                      dropdownValue,
                    }) => (
                      <ProductListRouteGuard
                        brandList={brandList}
                        productGroupList={productGroupList}
                        attributeList={attributeList}
                        fetchCounts={fetchCounts}
                        filteredItemName={filteredItemName}
                        setClearInput={setClearInput}
                        dropdownValue={dropdownValue}
                      />
                    )}
                  </Layout>
                }
              /> */}

              <Route path="/" element={<Home />} />
              <Route path="event/:event_id" element={<Event />} />
              <Route path="salesman_login/:pid" element={<Salesman_Login />} />
              <Route path="login" element={<Login />} />
              <Route path="forgetpass" element={<ForgetPass />} />
              <Route path="forgetpass2" element={<ForgetPass2 />} />
              <Route path="resetpassword" element={<ResetPassword />} />
              {/* <Route path="register" element={<Register />} />
              <Route path="register2" element={<Register2 />} />
              <Route path="register3" element={<Register3 />} />
              <Route path="register4" element={<Register4 />} />
              <Route
                path="register/register_validation/:token"
                element={<RegisterValidation />}
              /> */}
              <Route path="explorebrand" element={<ExploreBrand />} />
              <Route path="exploreproduct" element={<ExploreProduct />} />
              <Route
                path="productlist"
                element={<ProductList fetchCounts={fetchCounts} />}
              />
              <Route path="compareproduct" element={<CompareProduct />} />
              <Route
                path="productdetail/:item_id"
                element={
                  <ProductDetailWithKey
                    Component={ProductDetail}
                    fetchCounts={fetchCounts}
                  />
                }
              />
              {/* <Route
                path="purchasehistorydetail/:id"
                element={<PurchaseHistoryDetail />}
              /> */}
              <Route
                path="packageproductdetail/:item_id"
                element={<PackageProductDetail fetchCounts={fetchCounts} />}
              />
              <Route
                path="grouppackagedetail/:item_id"
                element={<GroupPackageDetail fetchCounts={fetchCounts} />}
              />
              <Route
                path="brandservicecenter"
                element={<BrandServiceCenter />}
              />
              <Route path="aboutus" element={<AboutUs />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="privacypolicy" element={<PrivacyPolicy />} />
              <Route
                path="refundreturnpolicy"
                element={<RefundReturnPolicy />}
              />
              <Route path="termsconditions" element={<TermsConditions />} />
              <Route
                path="/aftersalesservice"
                element={
                  <LanguageProvider>
                    <Outlet />
                  </LanguageProvider>
                }
              >
                <Route index element={<AfterSalesService />} />
                <Route path="registerserialno" element={<RegisterSerialNo />} />
                <Route
                  path="registerserialnobrunei"
                  element={<RegisterSerialNoBrunei />}
                />
                {/* <Route
                  path="registerserialnosingle"
                  element={<RegisterSerialNoSingle />}
                /> */}
                <Route path="menucenter" element={<MenuCenter />} />
                <Route
                  path="checkwarrantystatus"
                  element={<CheckWarrantyStatus />}
                />
                <Route path="warrantypolicy" element={<WarrantyPolicy />} />
                <Route path="usermanual" element={<UserManual />} />
                <Route
                  path="usermanual/safety"
                  element={<UserManualSafety />}
                />
                <Route
                  path="usermanual/installation"
                  element={<UserManualInstallation />}
                />
                <Route
                  path="usermanual/operating"
                  element={<UserManualOperating />}
                />
                <Route
                  path="usermanual/maintenance"
                  element={<UserManualMaintenance />}
                />
                <Route path="errorcode" element={<ErrorCode />} />
                <Route path="myticket" element={<MyTicket />} />
                <Route path="myticketdetail" element={<MyTicketDetail />} />
                <Route path="ticketsubmission" element={<TicketSubmission />} />
                <Route path="ticketsubmitted" element={<TicketSubmitted />} />
                <Route path="newinstallation" element={<NewInstallation />} />
                <Route path="preview" element={<Preview />} />
                <Route
                  path="previewwarrantypolicy"
                  element={<PreviewWarrantyPolicy />}
                />
                <Route
                  path="previewusermanual"
                  element={<PreviewUserManual />}
                />
                <Route
                  path="previewusermanualsections"
                  element={<PreviewUserManualSections />}
                />
                <Route path="previewerrorcode" element={<PreviewErrorCode />} />
              </Route>
              <Route path="test" element={<Test />} />
            </Routes>
          </main>
          {!hideNavAndFooter && <Footer />}
          {!hideNavAndFooter && <SideFeature />}

          {showNotification &&
            (overdueTotal > 0 ||
              unsuccessfulTotal > 0 ||
              unpaidOrderTotal > 0) && (
              <LoginNotif onClose={handleCloseNotification} />
            )}
          {/* auto-refresh handled by version polling useEffect */}
          {/* {showLoginNotice && (
            <MultiPurpose
              title="Session Expired"
              message="Your session has expired. Would you like to go to the login page?"
              yesText="Yes"
              noText="No"
              showYesLink={false}
              // yesLink="/login"
              showNoLink={true}
              noLink="/"
              onYes={() => {
                dispatch(logout());
                setShowLoginNotice(false);
                window.location.href = REDIRECT_LOGIN_URL;
              }}
              onNo={() => {
                dispatch(logout());
                setShowLoginNotice(false);
                window.location.href = "/";
              }}
              onClose={() => {
                dispatch(logout());
                setShowLoginNotice(false);
                window.location.href = "/";
              }}
            />
          )} */}
        </div>
      </Router>
    </TotalAmountContext.Provider>
  );
};

export default App;
